/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadChunkEndpointRequest
 */
export interface UploadChunkEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadChunkEndpointRequest
     */
    uploadId?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadChunkEndpointRequest
     */
    chunkNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof UploadChunkEndpointRequest
     */
    totalChunks?: number;
}

export function UploadChunkEndpointRequestFromJSON(json: any): UploadChunkEndpointRequest {
    return UploadChunkEndpointRequestFromJSONTyped(json, false);
}

export function UploadChunkEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadChunkEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadId': !exists(json, 'upload_id') ? undefined : json['upload_id'],
        'chunkNumber': !exists(json, 'chunk_number') ? undefined : json['chunk_number'],
        'totalChunks': !exists(json, 'total_chunks') ? undefined : json['total_chunks'],
    };
}

export function UploadChunkEndpointRequestToJSON(value?: UploadChunkEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upload_id': value.uploadId,
        'chunk_number': value.chunkNumber,
        'total_chunks': value.totalChunks,
    };
}


